import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const recharge = defineConnector({
  identifier: "recharge",
  name: "Recharge",
  tagLine: "Subscription payment management",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.rechargeapps\\.com/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "x-recharge-access-token",
        value: app.secret.apiKey,
      },
    ]),
  steps: [
    {
      title: "Find your Recharge API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to your [Recharge merchant portal](https://rechargepayments.com/login) and go to **Integrations → API Tokens**. Create a new API token with the permissions you need.",
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Enter the API credentials from your Recharge account settings.",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          placeholder:
            "sk_test_1p1_**************************************************",
          helperText: "The API Token for your Recharge account",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.rechargeapps.com/subscriptions",
  },
});
